import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { IVehiclesResponse } from 'src/apis/administration/administration.interfaces';
import { useRoutesAndSchedulesService } from 'src/apis/administration/useRoutesAndSchedulesService';

type TQueryError = IFHError<{ message: string }>;
export const getVehicleListKey = 'get-vehicle-list';

export const useVehicleListHook = (
  params: TPaginationParams,
  options?: UseQueryOptions<IVehiclesResponse, TQueryError>
): UseQueryResult<IVehiclesResponse, TQueryError> => {
  const { getVehicleList } = useRoutesAndSchedulesService();

  return useQuery<IVehiclesResponse, TQueryError>({
    queryKey: [getVehicleListKey, params],
    queryFn: () => getVehicleList(params),
    enabled: true,
    ...options,
  });
};
